import { format } from 'date-fns';
import ListActions from '../../../components/list-actions/list-actions.componenet';
import ListTableMainCell from '../../../components/list-table-main-cell/list-table-main-cell.component';
import TableCellStatus from '../../../components/table-cell-status/table-cell-status.component';
import { useMediaQuery } from 'react-responsive';

import { displayCellValue, displayCellValueNumberToTwoDecimal } from '../../../utils/column-values.util';

export const STOCK_TRANSFER_ORDERS_COLUMNS = [
    {
        Header: "Transfer Code",
        accessor: "transferCode",
        style: {
            position: "sticky",
            left: 0,
            top: 0,
            zIndex: 2
        },
        Cell: ({ value, row }) => {
            const uuid = row.original.uuid;
            return (
                <ListTableMainCell
                    value={value}
                    uuid={uuid}
                />
            )
        }
    },
    {
        Header: "From Branch",
        accessor: "fromLocation",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return `From: ${displayCellValue(value)}`;
            }

            return displayCellValue(value);
        }
    },
    {
        Header: "To Branch",
        accessor: "toLocation",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return `To: ${displayCellValue(value)}`;
            }

            return displayCellValue(value);
        }
    },
    {
        Header: "Status",
        accessor: "stockTransferStatus",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });
            const isRightAligned = true;

            if (!value) {
                return displayCellValue(value);
            }
            return (
                <div className={isMobileView && isRightAligned ?
                    'list-table__body__row__cell--right-aligned-mobile-cell' : ''}>
                    <TableCellStatus
                        value={value}
                    />
                </div>
            )
        }
    },
    {
        Header: "Requested Date",
        accessor: "requestedDate",
        Cell: ({ value }) => {
            const isMobileView = useMediaQuery({ maxWidth: 991 });

            if (isMobileView) {
                return null;
            }

            return (format(new Date(value), 'dd/MM/yyyy'))
        }
    },
    {
        Header: "Approval",
        accessor: "approvalStatus",
        Cell: ({ value }) => {
            if (!value) {
                return displayCellValue(value);
            }
            return (
                <TableCellStatus
                    value={value}
                />
            )
        }
    },
]